<template>
  <div class="form-group row">
    <label class="col-2 text-right">保障公式</label>
    <div class="col-10 d-inline-grid">
      <!-- 保障公式-1 -->
      <div class="checkbox radio-inline mb-15" v-if="!pageControl.showBenefitTypes">
        <span class="lh-40 ml-50">依</span>
        <select
          class="form-control form-control-inline form-wide w-250"
          :class="{ 'is-invalid': validate.isCalc_basisErr }"
          v-model="form.calc_basis"
        >
          <option value="">請選擇</option>
          <option
            v-for="item in pageControl.calculationBasis"
            :key="item.value"
            :value="item.value"
          >
            {{ item.text }}
          </option>
        </select>
        的
        <input
          type="number"
          class="form-control form-control-inline show-input w-100"
          :class="{ 'is-invalid': validate.isPeriod_lowerErr }"
          v-model="form.period_lower"
          :min="0"
          oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
          maxlength="8"
        />
        <select
          class="form-control form-control-inline form-wide w-100"
          :class="{ 'is-invalid': validate.isUnit_lowerErr }"
          v-model="form.unit_lower"
        >
          <option
            v-for="item in filterFormulaUnits"
            :key="item.value"
            :value="item.value"
          >
            {{ item.text }}
          </option>
        </select>
        <span v-if="pageControl.showUpper">
          ~
          <input
            type="number"
            class="form-control form-control-inline show-input w-100"
            :class="{ 'is-invalid': validate.isPeriod_upperErr }"
            v-model="form.period_upper"
            :min="0"
            oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
            maxlength="8"
          />
          <select
            class="form-control form-control-inline form-wide w-100"
            :class="{ 'is-invalid': validate.isUnit_upperErr }"
            v-model="form.unit_upper"
          >
            <option
              v-for="item in filterFormulaUnits"
              :key="item.value"
              :value="item.value"
            >
              {{ item.text }}
            </option>
          </select>
          <!-- {{
            pageControl.formulaUnits[form.unit_upper - 1]
              ? pageControl.formulaUnits[form.unit_upper - 1].text
              : ""
          }} -->
        </span>
        給付
      </div>

      <div class="checkbox radio-inline mb-15" v-if="pageControl.showBenefitTypes">
        <span class="lh-40 ml-50">依</span>
        <select
          class="form-control form-control-inline form-wide w-250"
          :class="{ 'is-invalid': validate.isCalc_basisErr }"
          v-model="form.calc_basis"
        >
          <option value="">請選擇</option>
          <option
            v-for="item in pageControl.calculationBasis"
            :key="item.value"
            :value="item.value"
          >
            {{ item.text }}
          </option>
        </select>
        給付
        <input
          type="number"
          class="form-control form-control-inline show-input w-100"
          :class="{ 'is-invalid': validate.isPeriod_lowerErr }"
          v-model="form.period_lower"
          :min="0"
          oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
          maxlength="8"
        />
        <select
          class="form-control form-control-inline form-wide w-100"
          :class="{ 'is-invalid': validate.isUnit_lowerErr }"
          v-model="form.unit_lower"
        >
          <option
            v-for="item in filterFormulaUnits"
            :key="item.value"
            :value="item.value"
          >
            {{ item.text }}
          </option>
        </select>
        ，最高給付上限
        <input
          type="number"
          class="form-control form-control-inline show-input w-100"
          v-model="form.benefit_max"
          :min="0"
          oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
          maxlength="8"
        />
        萬元
      </div>
    </div>
  </div>
</template>
<script>
import { commonMixin } from "@/mixins/common";
export default {
  name: "CoveragePageFormula",
  mixins: [commonMixin],
  data() {
    return {};
  },
  props: {
    pageControl: {
      type: Object,
      default: () => {
        return {
          showUpper: true,
          calculationBasis: [],
          formulaUnits: [
            {
              value: 1,
              text: "元",
            },
          ],
        };
      },
    },
    form: {
      type: Object,
      default: () => {
        return {
          calc_basis: "",
          period_lower: "",
          unit_lower: 1,
          period_upper: "",
          unit_upper: 1,
        };
      },
    },
    validate: {
      type: Object,
      default: () => {
        return {
          isCalc_basisErr: false,
          isPeriod_lowerErr: false,
          isUnit_lowerErr: false,
          isPeriod_upperErr: false,
          isUnit_upperErr: false,
        };
      },
    },
  },
  computed: {
    calculationBasisText() {
      return this.form.calc_basis
        ? this.pageControl.calculationBasis.filter(
            (obj) => obj.value == this.form.calc_basis
          )[0].text
        : "";
    },
    filterFormulaUnits() {
      return this.pageControl.formulaUnits.filter(
        (obj) =>
          this.calculationBasisText == "固定金額" ? obj.text == "元" : true
      );
    },
  },
  watch: {
    "form.period_upper": {
      handler: function(value) {
        if(value == null || value == ''){
          this.form.unit_upper = 0;
        } else if( this.form.unit_upper == 0 && (value != null && value != '')) {
          this.form.unit_upper = this.form.unit_lower;
        }
      },
      immediate: true,
      deep: true,
    },
    calculationBasisText: {
      handler: function(value) {
        if (value == "固定金額") {
          this.form.unit_lower = 1;
        }
      },
      deep: true,
    },
  },
};
</script>
